import styled, { css } from "styled-components";

export const Container = styled.div`
  padding: 12px 0 16px 12px;
  background-color: ${({ theme }) => theme.colorTokens.background.secondary};
`;

export const TitleContainer = styled.div`
  margin-bottom: 12px;
  display: flex;
  margin-right: 12px;
  align-items: center;

  h1 {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: Roboto-Bold, sans-serif;
  }
`;

export const Wrapper = styled.div<{ hasButton: boolean }>`
  display: flex;
  flex-direction: column;
  padding: ${({ hasButton }) => (hasButton ? "4px 0" : "8px 0")};
`;

export const RaceSelectorWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 15fr 23fr;
  gap: 16px 8px;
`;

export const ButtonsWrapper = styled.div<{
  withRightMargin?: boolean;
}>`
  display: flex;
  gap: 12px;
  ${({ withRightMargin }) =>
    withRightMargin &&
    css`
      margin-right: 12px;

      button:last-child {
        flex: 1;
        margin: 0;
      }
    `}

  button {
    min-width: 58px;
    flex-grow: 1;
  }
`;
